<template>
  <div id="stufocus">
    <van-tag @click="showPopup">重点关注考生 <b>{{PlugJson.PlugBody.StuFocusCount}}</b> 人</van-tag>
    <!-- {{PlugJson}} -->
    <van-popup
      v-model="stufocusList"
      position="bottom"
      round
      closeable
      class="popup-l1"
      get-container="#app"
    >
      <van-nav-bar :title="'重点关注考生 ' + PlugJson.PlugBody.StuFocusCount + ' 人'" left-text="列表" />
      <van-cell
        v-for="(item,index) in PlugJson.PlugBody.StuFocusList"
        :key="index"
        class="text-left"
      >
        <template slot="title">{{item.StuName}} - <b class="color-yellow">{{item.Memo}}</b> </template>
        <!-- <template slot="default">{{item.Memo}}</template> -->
        <template slot="label">
          <small>单位信息: {{item.DeptName}} - {{item.JobName}}</small>
          <br />
          <small>考试信息: {{item.AreaName}} - {{item.AddrName}}</small>
          <small>考场{{item.RoomNo}} - 座位{{item.SeatNo}}号</small>
        </template>
      </van-cell>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "stufocus",
  props: {
    PlugJson: Object
  },
  data() {
    return { stufocusList: false };
  },
  methods: {
    showPopup() {
      this.stufocusList = true;
    }
  }
};
</script>

<style scoped>
</style>